function comparer(otherArray) {
    return function (current) {
        return otherArray.filter(function (other) {
            return other.uuid == current.uuid && other.name == current.name
        }).length == 0;
    }
}

let differences = ((a, b) => {
    var onlyInA = a.filter(comparer(b));
    var onlyInB = b.filter(comparer(a));

    return onlyInA.concat(onlyInB);
})

export default {
    comparer, differences
}
